import useScrollAnimation from '../../hooks/useScrollAnimation';

interface QA {
  question: string;
  answer: string;
}

interface AIAnswerBlockProps {
  eyebrow?: string;
  headline: string;
  intro: string;
  qas: QA[];
}

const AIAnswerBlock = ({ eyebrow = 'AI & Search Optimized', headline, intro, qas }: AIAnswerBlockProps) => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-[#0a0a0a] overflow-hidden">
      <div ref={ref} className={`anim-section ${isVisible ? 'is-visible' : ''} max-w-screen-xl mx-auto flex flex-col lg:flex-row min-h-[520px]`}>
        {/* Dark left panel */}
        <div className="lg:w-[38%] bg-[#0d0b07] px-10 lg:px-14 py-20 flex flex-col justify-center relative">
          <div
            className="absolute top-8 left-8 font-display text-[180px] font-bold text-[#c8a951]/6 leading-none select-none pointer-events-none"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            &ldquo;
          </div>
          {eyebrow && (
            <p className="text-[#c8a951] text-xs uppercase tracking-[0.35em] font-semibold mb-5 relative z-10">{eyebrow}</p>
          )}
          <h2
            className="font-display text-3xl lg:text-4xl font-bold text-white leading-tight mb-6 relative z-10"
            style={{ fontFamily: '"Playfair Display", serif' }}
          >
            {headline}
          </h2>
          <p className="text-white/50 text-sm leading-relaxed mb-8 relative z-10">{intro}</p>
          <a
            href="tel:3204931454"
            className="inline-flex items-center gap-3 text-[#c8a951] text-sm font-semibold relative z-10 hover:text-[#e0c070] transition-colors"
          >
            <i className="ri-phone-line" /> 320.493.1454 — Free Estimate
          </a>
        </div>

        {/* Light right panel */}
        <div className="lg:w-[62%] bg-[#f7f4ef] px-10 lg:px-16 py-20">
          <div className="space-y-8">
            {qas.map((qa, i) => (
              <div key={i} className="border-l-2 border-[#c8a951] pl-6">
                <p
                  className="font-display text-lg font-semibold text-[#0a0a0a] mb-2"
                  style={{ fontFamily: '"Playfair Display", serif' }}
                >
                  {qa.question}
                </p>
                <p className="text-[#0a0a0a]/60 text-sm leading-relaxed">{qa.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIAnswerBlock;
